// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"PageHeaderPart_wrapper__odB09","pageHeader":"PageHeaderPart_pageHeader__gfle2","providerSubPage":"PageHeaderPart_providerSubPage__3qveS"};